import React from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { useMessage } from '../../hooks/message'
import { usePostRequest } from '../../hooks/request'
import UtilityBillsForm from './UtilityBillsForm'
import { UTILITY_BILLS_LIST } from '../../urls'
import Layout from '../../components/Layout'

export default function UtilityBillsCreate({ onCancel, categoryList, brandList }) {
    const { marketId } = useParams()
    console.log(marketId)
    const products = usePostRequest({ url: UTILITY_BILLS_LIST })
    const [showMessage] = useMessage()
    const history = useHistory()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data })
        if (success) {
            history.push(`/rent/${marketId}/utility-bills/`)
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <Layout>
            <UtilityBillsForm marketId={marketId} loading={products.loading} categoryList={categoryList} brandList={brandList}
                onCancel={onCancel}
                onSubmit={onSubmit} />
        </Layout>
    )
}
